//Unauthorized Access
import Unauthorized from "../Pages/Others/UnauthorizedAccess";

//General
import User from "../Pages/UserManagement/Users";
import Dashboard from "../Pages/Dashboard";
import Role from "../Pages/RoleManagement/Roles";

//Administrator
import ClientProfile from "../Pages/ClientProfile";
import CompanyProfile from "../Pages/CompanyProfile";

//Master Data
import Gender from "../Pages/MasterData/Gender";
import CivilStatus from "../Pages/MasterData/CivilStatus";
import Nationality from "../Pages/MasterData/Nationality";
import Country from "../Pages/MasterData/Country";
import Regions from "../Pages/MasterData/Regions";
import Province from "../Pages/MasterData/Province";
import City from "../Pages/MasterData/City";
import Barangay from "../Pages/MasterData/Barangay";
import AttachmentCategory from "../Pages/MasterData/AttachmentCategory";
import Industries from "../Pages/MasterData/Industry";
import EmploymentTypes from "../Pages/MasterData/EmploymentTypes";
import EmployeeStatus from "../Pages/MasterData/EmployeeStatus";
import JobLevel from "../Pages/MasterData/JobLevel";
import JobTitle from "../Pages/MasterData/JobTitle";

//Recruitment
import Candidates from "../Pages/Recruitment/Candidates";
import CandidateProfile from "../Pages/Recruitment/CandidateProfile";
import NewApplication from "../Pages/Recruitment/NewApplications";
import InProcessApplication from "../Pages/Recruitment/InProcessApplications";
import JobOfferApplications from "../Pages/Recruitment/JobOfferApplications";
import HiredApplications from "../Pages/Recruitment/HiredApplications";
import RejectedApplications from "../Pages/Recruitment/RejectedApplications";
import CancelledApplications from "../Pages/Recruitment/CancelledApplications";
import VoidedApplications from "../Pages/Recruitment/VoidedApplications";
import ViewApplication from "../Pages/Recruitment/ViewApplications";

//Employee
import EmployeeMasterList from "../Pages/Workforce/201File";
import EmployeeDirectory from "../Pages/Workforce/Employees";
import EmployeeProfile from "../Pages/Workforce/EmployeeProfile";

export const routes = [
  // ============================================================================
  // UNAUTHORIZED ACCESS MODULE
  // ============================================================================
  {
    path: `${process.env.PUBLIC_URL}/unauthorized`,
    element: <Unauthorized />,
  },
  // ============================================================================
  // GENERAL MODULE
  // ============================================================================
  {
    path: `${process.env.PUBLIC_URL}/dashboard`,
    element: <Dashboard />,
  },
  {
    path: `${process.env.PUBLIC_URL}/user-management/users`,
    element: <User />,
  },
  {
    path: `${process.env.PUBLIC_URL}/role-management/roles`,
    element: <Role />,
  },
  // ============================================================================
  // ADMINISTRATOR MODULE
  // ============================================================================
  {
    path: `${process.env.PUBLIC_URL}/client-profile`,
    element: <ClientProfile />,
  },
  {
    path: `${process.env.PUBLIC_URL}/client-profile/:code`,
    element: <CompanyProfile />,
  },
  // ============================================================================
  // PERSONAL INFORMATION MASTER DATA MODULE
  // ============================================================================
  {
    path: `${process.env.PUBLIC_URL}/master-data/gender`,
    element: <Gender />,
  },
  {
    path: `${process.env.PUBLIC_URL}/master-data/civil-status`,
    element: <CivilStatus />,
  },
  {
    path: `${process.env.PUBLIC_URL}/master-data/nationality`,
    element: <Nationality />,
  },
  // ============================================================================
  // EMPLOYMENT MASTER DATA MODULE
  // ============================================================================
  {
    path: `${process.env.PUBLIC_URL}/master-data/emp-type`,
    element: <EmploymentTypes />,
  },
  {
    path: `${process.env.PUBLIC_URL}/master-data/employee-status`,
    element: <EmployeeStatus />,
  },
  {
    path: `${process.env.PUBLIC_URL}/master-data/job-level`,
    element: <JobLevel />,
  },
  {
    path: `${process.env.PUBLIC_URL}/master-data/job-titles`,
    element: <JobTitle />,
  },
  // ============================================================================
  // ADDRESS & LOCATION MASTER DATA MODULE
  // ============================================================================
  {
    path: `${process.env.PUBLIC_URL}/master-data/country`,
    element: <Country />,
  },
  {
    path: `${process.env.PUBLIC_URL}/master-data/regions`,
    element: <Regions />,
  },
  {
    path: `${process.env.PUBLIC_URL}/master-data/province`,
    element: <Province />,
  },
  {
    path: `${process.env.PUBLIC_URL}/master-data/city`,
    element: <City />,
  },
  {
    path: `${process.env.PUBLIC_URL}/master-data/barangay`,
    element: <Barangay />,
  },
  // ============================================================================
  // ATTACHMENT CATEGORY MASTER DATA MODULE
  // ============================================================================
  {
    path: `${process.env.PUBLIC_URL}/master-data/attachment-category`,
    element: <AttachmentCategory />,
  },
  // ============================================================================
  // INDUSTRIES MASTER DATA MODULE
  // ============================================================================
  {
    path: `${process.env.PUBLIC_URL}/master-data/industries`,
    element: <Industries />,
  },
  // ============================================================================
  // RECRUITMENT MODULE
  // ============================================================================
  {
    path: `${process.env.PUBLIC_URL}/recruitment/candidates`,
    element: <Candidates />,
  },
  {
    path: `${process.env.PUBLIC_URL}/candidate-profile/:appl_no`,
    element: <CandidateProfile />,
  },
  {
    path: `${process.env.PUBLIC_URL}/recruitment/new-appl`,
    element: <NewApplication />,
  },
  {
    path: `${process.env.PUBLIC_URL}/recruitment/processed-appl`,
    element: <InProcessApplication />,
  },
  {
    path: `${process.env.PUBLIC_URL}/recruitment/job-offers-appl`,
    element: <JobOfferApplications />,
  },
  {
    path: `${process.env.PUBLIC_URL}/recruitment/hired-appl`,
    element: <HiredApplications />,
  },
  {
    path: `${process.env.PUBLIC_URL}/recruitment/rejected-appl`,
    element: <RejectedApplications />,
  },
  {
    path: `${process.env.PUBLIC_URL}/recruitment/cancelled-appl`,
    element: <CancelledApplications />,
  },
  {
    path: `${process.env.PUBLIC_URL}/recruitment/voided-appl`,
    element: <VoidedApplications />,
  },
  {
    path: `${process.env.PUBLIC_URL}/view-application/:appl_no`,
    element: <ViewApplication />,
  },
  // ============================================================================
  // EMPLOYEE MODULE
  // ============================================================================
  {
    path: `${process.env.PUBLIC_URL}/workforce/201file`,
    element: <EmployeeMasterList />,
  },
  {
    path: `${process.env.PUBLIC_URL}/workforce/employees`,
    element: <EmployeeDirectory />,
  },
  {
    path: `${process.env.PUBLIC_URL}/workforce/employee/:emp_no`,
    element: <EmployeeProfile />,
  },
];
